import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Declare plugins so then you can run it
 */
declare function init_plugins(): void;

/**
 * Component to manage 404 error
 */
@Component({
  selector: 'app-nopagefound',
  templateUrl: './nopagefound.component.html',
  styleUrls: ['./nopagefound.component.css'],
  imports: [RouterLink, TranslocoPipe],
})
export class NopagefoundComponent implements OnInit {
  /**
   * The year variable is declared
   * @param year Variable to save current year
   */
  year: number = new Date().getFullYear();

  /**
   * @ignore
   */
  constructor() {}

  /**
   * Run plugins to load the preloader
   */
  ngOnInit() {
    init_plugins();
  }
}
